import { render } from "./MostrarProcesos.vue?vue&type=template&id=6889b7fe&scoped=true"
import script from "./MostrarProcesos.vue?vue&type=script&lang=js"
export * from "./MostrarProcesos.vue?vue&type=script&lang=js"

import "./MostrarProcesos.vue?vue&type=style&index=0&id=6889b7fe&lang=css"
import "./MostrarProcesos.vue?vue&type=style&index=1&id=6889b7fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6889b7fe"]])

export default __exports__